__turbopack_context__.v({
  "container": "styles-module-scss-module__56lvha__container",
  "date": "styles-module-scss-module__56lvha__date",
  "dealCount": "styles-module-scss-module__56lvha__dealCount",
  "dealCountWrp": "styles-module-scss-module__56lvha__dealCountWrp",
  "emptyMessage": "styles-module-scss-module__56lvha__emptyMessage",
  "issuerTicker": "styles-module-scss-module__56lvha__issuerTicker",
  "name": "styles-module-scss-module__56lvha__name",
  "nameWrp": "styles-module-scss-module__56lvha__nameWrp",
  "row": "styles-module-scss-module__56lvha__row",
  "spinnerOverlay": "styles-module-scss-module__56lvha__spinnerOverlay",
  "table": "styles-module-scss-module__56lvha__table",
  "totalSize": "styles-module-scss-module__56lvha__totalSize",
});
